/**
 * Prefer the category outcome label ("Sound quality"). If the form config
 * is missing, turn a key like "sound_quality" into "Sound quality".
 */
export default function outcomeDisplayLabel(key, formConfig) {
  const fromConfig = (formConfig?.outcomes || []).find((outcome) => outcome.key === key)
    ?.label;
  if (fromConfig) return fromConfig;
  const spaced = String(key || "").replace(/_/g, " ").trim();
  if (!spaced) return "";
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
